import * as React from "react";
const SvgFiBrandsHbo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-hbo_svg__a)">
      <path
        fillRule="evenodd"
        d="M19.084 7.057c-2.707-.002-4.09 1.991-4.432 2.795.005-1.208-1.187-2.633-2.578-2.635H7.59v9.675l4.182.002c1.686 0 2.886-1.462 2.888-2.714.385.79 1.72 2.762 4.428 2.762v.002c2.71-.002 4.915-2.254 4.914-4.965a4.89 4.89 0 0 0-4.917-4.922M11.42 14.64h-1.33v-1.633h1.332c.387 0 .691.382.691.817s-.307.816-.693.816m.004-3.63h-1.33V9.373h1.332c.387 0 .691.382.691.817 0 .436-.306.818-.693.818m1.771.972h.002c.304-.039.812-.387.991-.61-.063.276-.069 1.073.005 1.35-.206-.315-.689-.702-.998-.74m5.893 2.462a2.463 2.463 0 1 1 0-4.925 2.463 2.463 0 0 1 0 4.925"
        clipRule="evenodd"
      />
      <path d="M19.088 13.918a1.936 1.936 0 1 0 0-3.872 1.936 1.936 0 0 0 0 3.872" />
      <path
        fillRule="evenodd"
        d="M7.042 16.897H4.413v-3.754H2.708v3.755H.01L0 7.221h2.708v3.6h1.706v-3.6h2.629v9.677zM23.463 7.89q.036 0 .056-.015a.05.05 0 0 0 .021-.044v-.002q0-.03-.02-.045a.1.1 0 0 0-.055-.015h-.095v.122h.096zm-.17-.187h.172q.075 0 .117.043.032.03.032.08v.004a.1.1 0 0 1-.025.076.12.12 0 0 1-.065.04l.104.146h-.088l-.093-.132h-.08v.133h-.073v-.39zm.148.536a.33.33 0 0 0 .307-.202.36.36 0 0 0 .002-.26.32.32 0 0 0-.288-.201h-.015a.3.3 0 0 0-.13.028.34.34 0 0 0-.106.544.32.32 0 0 0 .23.09m0 .04a.37.37 0 0 1-.265-.107.4.4 0 0 1-.075-.12.38.38 0 0 1 0-.287.38.38 0 0 1 .196-.196.38.38 0 0 1 .29 0 .371.371 0 0 1-.146.711"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-hbo_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsHbo;
